import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetVideoUploadToContentMutationVariables = Types.Exact<{
  input: Types.SetVideoUploadToContentInput;
}>;


export type SetVideoUploadToContentMutation = { __typename?: 'RootMutationType', setVideoUploadToContent?: { __typename?: 'ContentResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const SetVideoUploadToContentDocument = gql`
    mutation setVideoUploadToContent($input: SetVideoUploadToContentInput!) {
  setVideoUploadToContent(input: $input) {
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      providerName
      videoContain
      video {
        id
        rawUrl
        alternativeText
        transcodedUrl
        previewUrl
        streamUrl
        thumbUrl
        gifUrl
        gifWithIconUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
      image {
        ...StepImageUploadOnFeed
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
          gifUrl
          gifWithIconUrl
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}`;
export type SetVideoUploadToContentMutationFn = Apollo.MutationFunction<SetVideoUploadToContentMutation, SetVideoUploadToContentMutationVariables>;

/**
 * __useSetVideoUploadToContentMutation__
 *
 * To run a mutation, you first call `useSetVideoUploadToContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVideoUploadToContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVideoUploadToContentMutation, { data, loading, error }] = useSetVideoUploadToContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetVideoUploadToContentMutation(baseOptions?: Apollo.MutationHookOptions<SetVideoUploadToContentMutation, SetVideoUploadToContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVideoUploadToContentMutation, SetVideoUploadToContentMutationVariables>(SetVideoUploadToContentDocument, options);
      }
export type SetVideoUploadToContentMutationHookResult = ReturnType<typeof useSetVideoUploadToContentMutation>;
export type SetVideoUploadToContentMutationResult = Apollo.MutationResult<SetVideoUploadToContentMutation>;
export type SetVideoUploadToContentMutationOptions = Apollo.BaseMutationOptions<SetVideoUploadToContentMutation, SetVideoUploadToContentMutationVariables>;